// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 10.5L4.75 13.25L7.5 10.5M4.75 13.25V2.75',
  'M8.5 5.5L11.25 2.75L14 5.5M11.25 2.75V13.25',
];
